import { render, staticRenderFns } from "./deviceTypePermission.vue?vue&type=template&id=1eb67a84&scoped=true&"
import script from "./deviceTypePermission.vue?vue&type=script&lang=js&"
export * from "./deviceTypePermission.vue?vue&type=script&lang=js&"
import style0 from "./deviceTypePermission.vue?vue&type=style&index=0&id=1eb67a84&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1eb67a84",
  null
  
)

export default component.exports